export enum PhoneType {
  Home = 'home',
  Work = 'work',
  Mobile = 'mobile',
  Fax = 'fax',
  Primary = 'primary',
}
